module.exports = __webpack_public_path__ + "img/energieverbrauch.0395c073.png";